var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"more-style"},[_c('p',{staticClass:"title-item-info"},[_vm._v("链接")]),_c('link-selector',{model:{value:(_vm.$$FormData.to_link),callback:function ($$v) {_vm.$set(_vm.$$FormData, "to_link", $$v)},expression:"$$FormData.to_link"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }